import { useLingui } from '@lingui/react/macro'

import { getProductItems } from '../helpers/getProductItems'
import { getEcommerce } from '../helpers/getEcommerce'

import type { ISubCreateProps } from '../type'

import { api } from '@/utils/api'
import { useAntdContext } from '@/contexts/AntdContext/hooks'
import { useAnalyticsData } from '@/hooks/analyticsData'
import { throwGlobalErrorMessage } from '@/utils/error'


import { useRouter } from '@/hooks/routes';
// 四子产品，如果购买了一个，再买别的产品就用这个接口
export function useSubCreate({
  onPaySuccess,
  onPayFail,
}: {
  onPaySuccess?: () => void
  onPayFail?: () => void
}) {
  const { mutateAsync, isLoading } = api.subLog.subCreate.useMutation()
  const { message } = useAntdContext()

  const { t } = useLingui()

  const router = useRouter()
  const { trackCustomEvent } = useAnalyticsData()

  const subCreate = async ({
    appName,
    pricesId,
    userId,
    productPriceList,
    customerId,
    platformName,
  }: Required<ISubCreateProps>) => {
    const { upgrade, timestamp } = await mutateAsync({
      appName,
      pricesId,
    })
    if (upgrade && timestamp) {
      onPaySuccess?.()
      // 升级成功
      message.success(t`Your payment was successful!`)
      const items = getProductItems({
        productPriceList,
        appName,
      }).map((item) => {
        return {
          ...item,
          item_category5: customerId,
        }
      })

      const { ecommerce } = getEcommerce({
        userId,
        productPriceList,
        items,
        appName,
        paymentPlatform: platformName,
      })
      trackCustomEvent({
        name: 'purchase',
        meta: ecommerce,
        latestUserId: userId,
      })

      setTimeout(() => {
        window.location.reload()
      }, 2000)
    } else {
      onPayFail?.()
      // 升级失败
      throwGlobalErrorMessage(
        t`We were unable to process your payment. Please check the status of your payment method and try again.`,
      )
    }
    return {
      ok: !!upgrade,
    }
  }
  return {
    subCreate,
    subCreateLoading: isLoading,
  }
}
